import React from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { CHECKOUT_URL, PRICE_FULL, PRICE_TODAY, PRODUCT_ALT, PRODUCT_IMG, PRODUCT_NAME } from './constants';
export function FinalCTA() {
  return <section className="border-t-8 border-brand-orange bg-brand-graphite px-4 py-5 text-white" data-id="element-43" data-mp="c83odh06bg3y">
      <div className="mx-auto max-w-3xl text-center" data-id="element-44" data-mp="83m8hswxpmyg">
        <p className="mb-1 font-display text-[11px] font-semibold uppercase tracking-widest text-brand-gold sm:text-sm" data-id="element-45" data-mp="m4f1283oe7yx">
          Une dernière opportunité
        </p>
        <div className="mx-auto mb-2 max-w-2xl space-y-1 text-[13px] font-medium leading-snug text-white/85 sm:text-base" data-id="element-46" data-mp="h413xl3m4ifo">
          <p data-id="element-47" data-mp="qvx0ustyq2ib">
            Chaque semaine, de nouvelles vidéos apparaissent. De nouveaux appareils. De nouveaux
            tutoriels. De nouvelles automatisations. De nouvelles technologies. Mais accumuler
            toujours plus d’informations ne signifie pas avoir une méthode.
          </p>
          <p data-id="element-48" data-mp="2c4wo4ojgcche">
            Vous pouvez continuer à chercher chaque réponse séparément... Ou commencer avec un système
            organisé qui vous montre quoi apprendre, dans quel ordre et comment l’appliquer.
          </p>
          <p className="font-semibold text-white" data-id="element-49" data-mp="2m1sy6yp016o2">
            Comprenez les fondamentaux. Concevez votre système. Installez et configurez les appareils.
            Créez vos automatisations. Intégrez vos écosystèmes. Réalisez des projets complets.
          </p>
        </div>

        <a href={CHECKOUT_URL} className="mb-2 block" aria-label={`Acheter ${PRODUCT_NAME}`} data-id="element-50" data-mp="302c15relxmjd">
          <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[210px] object-contain drop-shadow-2xl transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-51" data-mp="34tlsqxjpuzxw" />
        </a>

        <div className="mb-2 rounded-2xl border border-white/15 bg-white/10 p-3" data-id="element-52" data-mp="3et2w38bhx1qp">
          <p className="font-display text-xs font-bold uppercase leading-snug tracking-wide text-white sm:text-base" data-id="element-53" data-mp="3iu4vbp5exdso">
            {PRODUCT_NAME}
          </p>
          <p className="mb-1 text-[11px] font-semibold text-white/85 sm:text-sm" data-id="element-54" data-mp="1ep8rxw65riaf">
            Système Complet 6-en-1 pour Apprendre, Installer et Maîtriser la Domotique + 5 Bonus
            Premium
          </p>
          <p className="text-sm sm:text-lg" data-id="element-55" data-mp="1nq6su5lav9os">
            <span className="text-white/60 line-through" data-id="element-56" data-mp="1nodq31dt59m2">Prix Habituel : {PRICE_FULL}</span>{' '}
            |{' '}
            <span className="font-display font-extrabold text-brand-gold" data-id="element-57" data-mp="22gxojoq0isx6">
              AUJOURD’HUI SEULEMENT : {PRICE_TODAY}
            </span>
          </p>
        </div>

        <CTAButton href={CHECKOUT_URL} className="mx-auto mb-2 max-w-md" data-id="element-58" data-mp="2be825gqayu59">
          🚀 OUI ! JE VEUX MON {PRODUCT_NAME}
        </CTAButton>

        <TrustRow tone="dark" showDelivery data-id="element-59" data-mp="27c34m6wqhddc" />
      </div>
    </section>;
}